package com.macrofocus.trenddisplay.timeseriesplot

abstract class AbstractTimeSeriesPlotModel<Row, Column> : TimeSeriesPlotModel<Row, Column> {
    private val listeners: MutableList<TimeSeriesPlotListener> = ArrayList<TimeSeriesPlotListener>()

    /**
     * {@inheritDoc}
     */
    override fun addTimeSeriesPlotListener(listener: TimeSeriesPlotListener) {
        listeners.add(listener)
    }

    /**
     * {@inheritDoc}
     */
    override fun removeTimeSeriesPlotListener(listener: TimeSeriesPlotListener) {
        listeners.remove(listener)
    }

    protected fun fireTimeSeriesPlotChanged() {
        for (listener in listeners) {
            listener.timeSeriesPlotChanged()
        }
    }
}
